import { cloneElement as E, createElement as A, isValidElement as N } from "react";
import { clsx as T } from "../../../clsx/dist/clsx.js";
import { Curve as d } from "../shape/Curve.js";
import { Cross as D } from "../shape/Cross.js";
import { getCursorRectangle as B } from "../util/cursor/getCursorRectangle.js";
import { Rectangle as I } from "../shape/Rectangle.js";
import { getRadialCursorPoints as _ } from "../util/cursor/getRadialCursorPoints.js";
import { Sector as z } from "../shape/Sector.js";
import { getCursorPoints as K } from "../util/cursor/getCursorPoints.js";
import { filterProps as $ } from "../util/ReactUtils.js";
function u(e) {
  "@babel/helpers - typeof";
  return u = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, u(e);
}
function P(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    t && (o = o.filter(function(f) {
      return Object.getOwnPropertyDescriptor(e, f).enumerable;
    })), r.push.apply(r, o);
  }
  return r;
}
function s(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? P(Object(r), !0).forEach(function(o) {
      R(e, o, r[o]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : P(Object(r)).forEach(function(o) {
      Object.defineProperty(e, o, Object.getOwnPropertyDescriptor(r, o));
    });
  }
  return e;
}
function R(e, t, r) {
  return t = V(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function V(e) {
  var t = q(e, "string");
  return u(t) == "symbol" ? t : t + "";
}
function q(e, t) {
  if (u(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var o = r.call(e, t);
    if (u(o) != "object") return o;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function Y(e) {
  var t, r, o = e.element, f = e.tooltipEventType, g = e.isActive, n = e.activeCoordinate, O = e.activePayload, m = e.offset, S = e.activeTooltipIndex, h = e.tooltipAxisBandSize, p = e.layout, y = e.chartName, i = (t = o.props.cursor) !== null && t !== void 0 ? t : (r = o.type.defaultProps) === null || r === void 0 ? void 0 : r.cursor;
  if (!o || !i || !g || !n || y !== "ScatterChart" && f !== "axis")
    return null;
  var a, c = d;
  if (y === "ScatterChart")
    a = n, c = D;
  else if (y === "BarChart")
    a = B(p, n, m, h), c = I;
  else if (p === "radial") {
    var l = _(n), j = l.cx, w = l.cy, v = l.radius, x = l.startAngle, C = l.endAngle;
    a = {
      cx: j,
      cy: w,
      startAngle: x,
      endAngle: C,
      innerRadius: v,
      outerRadius: v
    }, c = z;
  } else
    a = {
      points: K(p, n, m)
    }, c = d;
  var b = s(s(s(s({
    stroke: "#ccc",
    pointerEvents: "none"
  }, m), a), $(i, !1)), {}, {
    payload: O,
    payloadIndex: S,
    className: T("recharts-tooltip-cursor", i.className)
  });
  return /* @__PURE__ */ N(i) ? /* @__PURE__ */ E(i, b) : /* @__PURE__ */ A(c, b);
}
export {
  Y as Cursor
};
